var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFields(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    viewBox: "0 0 102.05 102.05",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Laag 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m62.9 29.64h13.74l-13.74-14.41z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m81.12 60.19-19.75 19.75-2.67 7.75 7.75-2.66 19.76-19.76z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m85.74 54.48h5.17v7.19h-5.17z",
    fill: "none",
    transform: "matrix(.707 -.707 .707 .707 -15.19 79.47)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#161616"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m47.25 89h-25.15v-75.94h36.8v18.58a2 2 0 0 0 2 2h17.85v12.23a2 2 0 1 0 4 0v-14.81a2 2 0 0 0 -.55-1.38l-19.07-20a2 2 0 0 0 -1.45-.62h-41.58a2 2 0 0 0 -2 2v79.94a2 2 0 0 0 2 2h27.15a2 2 0 1 0 0-4zm29.39-59.36h-13.74v-14.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.3 41.49h17.25a2 2 0 0 0 0-4h-17.25a2 2 0 0 0 0 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.55 47.85h-32.25a2 2 0 0 0 0 4h32.25a2 2 0 0 0 0-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.55 60.2a2 2 0 0 0 -2-2h-32.25a2 2 0 0 0 0 4h32.25a2 2 0 0 0 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.3 68.56a2 2 0 0 0 0 4h21.75a2 2 0 0 0 0-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.93 57.37-7.93-7.91a2 2 0 0 0 -2.83 0l-28 28a2.13 2.13 0 0 0 -.48.77l-4.11 12.03a2 2 0 0 0 1.9 2.66 2.16 2.16 0 0 0 .65-.11l12.06-4.15a2 2 0 0 0 .76-.48l28-28a2 2 0 0 0 .59-1.41 2 2 0 0 0 -.61-1.4zm-30.48 27.63-7.75 2.69 2.67-7.75 19.75-19.76 5.09 5.09zm22.55-22.56-5-5.08 3.66-3.66 5.08 5.09z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFields);
export default __webpack_public_path__ + "static/media/fields.ff0ad5f33457401209eccd4938979184.svg";
export { ForwardRef as ReactComponent };